import { render } from "./appheader.vue?vue&type=template&id=e055a4de"
import script from "./appheader.vue?vue&type=script&lang=js"
export * from "./appheader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__